import './App.css';
import Divider from '@material-ui/core/Divider';

function Blog() {
    return (
      <div align="left" className="content_page">
          <h1 className="content_page">
            April 2023
          </h1>
          <Divider /> 
          <p>
            I am excited to vounteer and share our work on Crash types for intermittent computing at <b>ESOP</b> this year.
          </p>
          <br />

          <h1 className="content_page">
            February 2023
          </h1>
          <Divider /> 
          <p>
            I am grateful for the opportunity to attend <b>FoPSS</b> this year. I learned about probabilistic programming and quantitative analysis.
          </p>
          <br />

          <h1 className="content_page">
            January 2023
          </h1>
          <Divider /> 
          <p>
            Looking forward to <b>student volunteering at POPL</b> this year. See you in Boston!
          </p>
          <br />

          <h1 className="content_page">
            December 2022
          </h1>
          <Divider /> 
          <p>
            Our work on <b>Modal Crash Types for Intermittent Computing</b> has been accepted to ESOP 2023.
          </p>
          <br />

          <h1 className="content_page">
            June 2022
          </h1>
          <Divider /> 
          <p>
            Oregon-bound! Excited for all that I will learn at <b>Oregon Programming Languages Summer School</b> this year!
          </p>
          <br />

          <h1 className="content_page">
            April 2022
          </h1>
          <Divider /> 
          <p>
            Awarded the <b>NSF Graduate Research Fellowship</b>! Great thanks to my letter writers, advisors, and 
            professors both at CMU and KU who have fostered my growth. It takes a village!
          </p>

          <p>
            Grateful for the opportunity to attend <b>CRA-WP Grad Cohort</b> this year! I networked with 
            many passionate computer scientists and gained valuable insight from industry and academic mentors.
          </p>
          <br />

          <h1 className="content_page">
            January 2022
          </h1>
          <Divider /> 
          <p>
            Had a blast at <b>POPL PLMW</b> this year! One of my favorite bits of wisdom is that "research is a conversation" (Stephanie Weirich).
          </p>
          <br />

          <h1 className="content_page">
            December 2021
          </h1>
          <Divider /> 
          <p>
            <b>Woohoo, our team placed 2nd in the LFCPS Grand Prix!</b> Special thanks to <a href="https://lfcps.org" target="_blank" rel="noreferrer">Andr&#233; Platzer</a> for a great 
            semester and to all the industry judges who came to hear about our project. Excited about our work on identifying 
            modeling errors!
          </p>
          <br />
{/* 
          <h1 className="content_page">
            October 2021
          </h1>
          <Divider /> 
          <p>
            <b>It's a girl!</b> Thrilled to be co-advised by Jan Hoffmann and Limin Jia. I am so excited for all
            that I will learn!
          </p>
          <br />
*/}
          <h1 className="content_page">
            August 2021
          </h1>
          <Divider /> 
          <p>
            "We're not in Kansas anymore", said a very confused Dorothy to an even more confused Toto. Same here 
            (but less confused). Just moved to Pittsburgh, and I am thrilled to start grad school at 
            Carnegie Mellon this fall! (no flying monkeys yet, but I'll let you know of any sightings.)
          </p>
          <br />

          <h1 className="content_page">
            July 2021
          </h1>
          <Divider />
          <p>
            Published website. Hello world :)
          </p>
        
      </div>
    );
  }
  
  export default Blog;
  